/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcExternalRectangleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M2.1 3a.9.9 0 0 1 .9-.9h7.5v1.8H3.9v16.2h16.2v-6.6h1.8V21a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9zM15 2.1h6a.9.9 0 0 1 .9.9v6h-1.8V5.173l-7.464 7.464-1.272-1.273L18.827 3.9H15z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcExternalRectangleRegular;
